import moment from 'moment';

class Note {
  constructor({id, name, author, modified, body, analysisID, systemID, customerID}) {
    this.id = id;
    this.name = name;
    this.author = author;
    this.modified = moment(modified);
    this.body = body;
    this.analysisID = analysisID;
    this.systemID = systemID;
    this.customerID = customerID;
  }

  toApiFormat() {
    const obj = {...this};

    const processName = key => {
      if (key === 'id') {
        return 'ID';
      }

      return key.slice(0, 1).toUpperCase() + key.slice(1);
    };

    return Object.keys(obj)
      .filter(x => obj.hasOwnProperty(x) && typeof obj[x] !== 'function')
      .reduce((acc, x) => {
        acc[processName(x)] = obj[x];
        return acc;
      }, {});
  }

  static fromApiFormat(api) {
    const processName = key => {
      if (key === 'ID') {
        return 'id';
      }

      return key.slice(0, 1).toLowerCase() + key.slice(1);
    };

    return new Note(Object.keys(api)
      .reduce((acc, x) => {
        acc[processName(x)] = api[x];
        return acc;
      }, {}));
  }
}

export default Note;
